export const query = (state) => {
  return {
    name: state.name,
    email: state.email
  }
}

export const getDelegations = (state) => {
  return state.delegations
}

const apificateAlerts = (n) => {
  return {
    email: n.email,
    onIssued: n.emited,
    onRead: n.read,
    onAccepted: n.accepted,
    onRejected: n.refused,
    onRectified: n.edited,
    afterSevenDays: n.ignored
  }
}

export const apificate = (state) => {
  return {
    issuedInvoices: apificateAlerts(state.billToCharge.form),
    receivedInvoices: apificateAlerts(state.billToPay.form),
    issuedSelfinvoices: apificateAlerts(state.autoBillToCharge.form),
    receivedSelfinvoices: apificateAlerts(state.autoBillToPay.form)
  }
}

export const loaded = (state) => {
  return state.loaded
}

export const issuedInvoices = (state) => {
  return state.billToCharge.form
}
export const receivedInvoices = (state) => {
  return state.billToPay.form
}
export const issuedSelfinvoices = (state) => {
  return state.autoBillToCharge.form
}
export const receivedSelfinvoices = (state) => {
  return state.autoBillToPay.form
}